import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { QbCustomer } from '../../../customer/data/qb-customer';
import { ProjectSale } from '../../data/project-sale';
import { QBService } from '../../data/qb.service';
import { MatSnackBarRef, SimpleSnackBar, MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationService } from 'primeng/api';
import { MvcExceptionResponse } from 'projects/core/src/lib/core/data/mvc-exception-response';
import { MatDialog } from '@angular/material/dialog';
import { SendInvoiceDialogComponent } from '../send-invoice-dialog/send-invoice-dialog.component';
import { Observable, Subscription, Subject } from 'rxjs';
import { takeUntilDestroyed } from 'projects/core/src/public-api';
import { filter } from 'rxjs/operators';
import { QBFile } from '../../data/qb-file';
import { EmailPreviewComponent } from '../email-preview/email-preview.component';
import { CreateEstiinvDialogComponent } from '../create-estiinv-dialog/create-estiinv-dialog.component';
import { environment } from 'projects/desktop/src/environments/environment';

@Component({
    selector: 'app-est-inv-info',
    templateUrl: './est-inv-info.component.html',
    styleUrls: ['./est-inv-info.component.scss'],
    providers: [ConfirmationService]
})
export class EstInvInfoComponent implements OnInit, OnDestroy {
    @Input()
    sale: ProjectSale;

    @Input()
    projectId: number;

    @Input()
    qbServClasses = [];

    @Input()
    isMobile: boolean;

    @Input()
    baseQbServClasses = [];

    @Input()
    qbCustomers: QbCustomer[];

    @Input()
    loadingEvents: Observable<string>;

    filesLoading = false;

    private loadingEvents$: Subscription;

    selectedQbCustomer: QbCustomer;

    paymentsList: ProjectSale[];

    customerEmail: string;
    billAddr: string;
    shipAddr: string;
    dueDate: Date;
    invDate: Date;

    loadingSpinner: boolean;
    saveNSendLoading: boolean;
    deleteLoadingSpinner: boolean;

    activeSnackBar: MatSnackBarRef<SimpleSnackBar>;

    @Output()
    updateInvoice = new EventEmitter<ProjectSale>();

    @Output()
    deleteInvEst = new EventEmitter<string>();

    @Output()
    pdfUrl = new EventEmitter<QBFile>();

    showAddInfoAfterSave = false;

    qbFiles: QBFile[];

    saveAndSendSubj$ = new Subject<void>();

    constructor(
        protected dialog: MatDialog,
        private snackBar: MatSnackBar,
        protected qbService: QBService,
        protected confirmationService: ConfirmationService,

    ) {
    }

    ngOnInit(): void {
        this.selectedQbCustomer = this.qbCustomers.find(cus => cus.displayName === this.sale.customerRef.name);

        this.customerEmail = this.sale.billEmail ? this.sale.billEmail.address : '';

        // tslint:disable-next-line: max-line-length
        this.fillAddresses('billAddr');
        this.fillAddresses('shipAddr');


        this.dueDate = this.sale.dueDate;
        this.invDate = this.sale.metaData ? this.sale.metaData.createTime : null;

        if (this.sale.paymentsList) {
            this.paymentsList = this.sale.paymentsList;
        }

        this.subToLoading();
    }

    subToLoading() {
        this.loadingEvents
            .pipe(
                filter(saleId => saleId === this.sale.id)
            ).subscribe(emit => {
                this.getFiles()
            })
    }

    getFiles() {
        this.filesLoading = true;

        this.qbService.getQBFiles(this.sale.type.toLowerCase(), this.sale.id).subscribe(files => {
            this.qbFiles = files;
            this.filesLoading = false;
        })
    }



    openFile(qbFile: QBFile) {
        if (qbFile.contentType === 'application/pdf') {
            this.pdfUrl.emit(qbFile)
        }
        else {
            this.downloadFile(qbFile)
        }
    }

    downloadFile(qbFile: QBFile) {
        window.open(qbFile.tempDownloadUri, '_blank');
    }

    fillAddresses(field: string) {
        if (this.sale[field]) {
            const line1 = this.sale.customerRef.name ? this.sale.customerRef.name : ''
            const line2 = this.sale[field].line1 ? this.sale[field].line1 : ''

            const templine1 = this.sale[field].city ? this.sale[field].city : ''
            const templine2 = this.sale[field].countrySubDivisionCode ? this.sale[field].countrySubDivisionCode : ''
            const templine3 = this.sale[field].postalCode ? this.sale[field].postalCode : ''
            const templine4 = this.sale[field].country ? this.sale[field].country : ''


            const line3 = templine1 + ', ' + templine2 + ' ' + templine3 + ' ' + templine4


            this[field] = (this.sale[field] ? line1 + '\r\n' + line2 + '\r\n' + (line3 !== ',   ' ? line3 : '') : '').trim();
        }
    }

    fillObjectFromAddress(field: string) {
        if (this.sale[field]) {
            const arr = this[field].split('\n')

            // this.sale.customerRef.name = arr[0] // Customer name
            this.sale[field].line1 = arr[1] // Line1 name

            if (arr[2]) {
                const tempInfo = arr[2].split(', ')
                const city = tempInfo[0]
                this.sale[field].city = city;

                if (tempInfo[1]) {
                    const tempAdd = tempInfo[1].split(' ')

                    this.sale[field].countrySubDivisionCode = tempAdd[0] // CountrySub Code
                    this.sale[field].postalCode = tempAdd[1] // postal code
                    this.sale[field].country = tempAdd[2] // country code
                }
            }

        }
    }

    qbChanged(qbCust) {

    }

    updateCustomer() {

    }

    saveInfoButton() {
        this.loadingSpinner = true;
        this.saveInfo();
    }

    saveInfo() {
        const type = this.sale.type;

        if (this.sale.dueDate) {
            this.sale.dueDate = new Date(this.dueDate.getTime());
        }

        this.sale.billEmail.address = this.customerEmail;

        this.fillObjectFromAddress('billAddr');
        this.fillObjectFromAddress('shipAddr');

        this.qbService.updateSale(this.sale).subscribe(nSale => {
            this.showAddInfoAfterSave = false;
            this.sale = nSale;

            if (!this.sale.txnStatus) {
                if (this.sale.balance === 0) {
                    Object.assign(this.sale, {
                        txnStatus: 'Paid',
                        statusNum: 100
                    });

                }
                else if (this.sale.balance === this.sale.totalAmt) {
                    Object.assign(this.sale, {
                        txnStatus: 'Open',
                        statusNum: 0
                    })
                }
                else {
                    const statusNum = 100 - (Math.round((this.sale.balance / this.sale.totalAmt) * 100));
                    Object.assign(this.sale, {
                        txnStatus: `Paid ${statusNum}%`,
                        statusNum
                    })
                }
            }
            if (this.sale.balance >= 0 && this.sale.totalAmt >= 0) {
                Object.assign(this.sale, { recievedPayments: this.sale.totalAmt - this.sale.balance })
            }

            // if (this.sale.balance >= 0 && this.sale.totalAmt >= 0) {
            // 	if (this.sale.totalAmt >= this.sale.balance) {
            // 		Object.assign(this.sale, { balanceDue: this.sale.totalAmt - this.sale.balance })
            // 	}
            // 	else {
            // 		Object.assign(this.sale, { balanceDue: 0 })
            // 	}
            // }

            Object.assign(this.sale, { type })

            this.updateInvoice.emit(this.sale)

            this.loadingSpinner = false;

            this.saveAndSendSubj$.next();

        }, error => {
            this.loadingSpinner = false;

            if (error instanceof MvcExceptionResponse) {
                this.openSnackBar(error.message)
            }
            else {
                this.openSnackBar('Error!')
            }
        })
    }

    openSnackBar(message: string, duration = 5000) {
        const panelClass = 'error-snackbar';

        if (this.activeSnackBar) {
            this.activeSnackBar.dismiss();
        }

        this.activeSnackBar = this.snackBar.open(message, '', {
            duration,
            panelClass,
            verticalPosition: 'top',
        });
    }

    openGoodSnackBar(message: string, duration = 5000) {
        const panelClass = 'good-snackbar';

        if (this.activeSnackBar) {
            this.activeSnackBar.dismiss();
        }

        this.activeSnackBar = this.snackBar.open(message, '', {
            duration,
            panelClass,
            verticalPosition: 'top',
        });
    }

    sendInQb() {
        let baseLink = `https://app.qbo.intuit.com/app`;

        if (environment.dev) {
            baseLink = `https://app.sandbox.qbo.intuit.com/app`
        }

        window.open(`${baseLink}/${this.sale.type.toLowerCase()}?txnId=${this.sale.id}`, '_blank');
    }

    sendEmail() {
        this.saveNSendLoading = true;

        this.saveInfo();

        this.saveAndSendSubj$.subscribe(emit => {

            this.saveNSendLoading = false;

            const dialogRef = this.dialog.open(EmailPreviewComponent, {
                data: {
                    sale: this.sale
                },
                panelClass: 'email-preview-dialog'
            });

            dialogRef.afterClosed().subscribe(result => {
                this.saveAndSendSubj$ = new Subject();

                if (result && result[0] === 'Success!') {
                    this.openGoodSnackBar(result[1])
                }
                else if (result && result[0] === 'Error!') {
                    this.openSnackBar(result[1])
                }
            });
        })
    }

    deleteEstInv() {
        this.deleteLoadingSpinner = true;

        this.confirmationService.confirm({
            header: `Delete ${this.sale.type}?`,
            message: `Delete ${this.sale.customerRef.name} ${this.sale.type}?`,
            accept: () => {


                if (this.sale.type === 'Estimate') {

                    this.qbService.deleteEstimate(this.sale.id).subscribe(cabs => {
                        this.openGoodSnackBar('Success!', 5000)
                        this.deleteLoadingSpinner = false;
                        this.deleteInvEst.emit(this.sale.id)
                    }, error => {
                        this.openSnackBar('Error!', 5000)
                        this.deleteLoadingSpinner = false;
                    })

                }
                else if (this.sale.type === 'Invoice') {

                    this.qbService.deleteInvoice(this.sale.id).subscribe(cabs => {
                        this.openGoodSnackBar('Success!', 5000)
                        this.deleteLoadingSpinner = false;
                        this.deleteInvEst.emit(this.sale.id)
                    }, error => {
                        this.openSnackBar('Error!', 5000)
                        this.deleteLoadingSpinner = false;
                    })

                }
            },
            reject: () => {
                this.deleteLoadingSpinner = false;
            }
        });
    }

    showAfterSave() {
        this.showAddInfoAfterSave = true;
    }


    createInvoice() {
        const dialogRef = this.dialog.open(CreateEstiinvDialogComponent, {
            data: {
                sale: this.sale,
                projectId: this.projectId
            },
            panelClass: 'estinv-window-dialog'
        });

        dialogRef.afterClosed().subscribe(result => {
        });
    }

    ngOnDestroy() {
    }

    blurActiveElement() {
        setTimeout(() => {
            const activeElement = document.activeElement;
            if (activeElement && activeElement instanceof HTMLElement)
                activeElement.blur()
        }, 5);
    }


}
